<template>
    <div class="accessories-view view">
        <instructions titleKey="accessories" :property="state.productFamily == 'seven' ? 'accessoriesHelpContent' : 'accessoriesHelpContentOne'" />

        <worktop-drawing />

        <div class="wrapper">
            <div class="section-content">
                <div class="accessory-list">
                <option-list :optionList="ui.accessories"
                    v-model="state.accessories"
                    :withImages="true"
                    :enableZoom="true"
                    imageScaling="full"
                    :linkText="ui.t('worktopMaterialPreviewLinkText')"
                    :itemClasses="[ 'col-2' ]"
                    :multiple="true" />
                </div>
            </div>
        </div>

        <div class="navigation">
            <div class="wrapper">
                <router-link :to="ui.functionalAreaAvailable ? '/functional-area' : 'hobcutout'" v-html="ui.t('previous')" />
                <router-link to="/summary" v-html="ui.t('next')" class="next" />
            </div>
        </div>
    </div>
</template>

<script async setup lang="ts">
import { useRouter } from 'vue-router';
import { useState, useUI } from '../store';

const { state } = useState();
const { ui } = useUI();
const router = useRouter();

async function mounted() {
    if (state.disableAccessories) {
        router.push("/summary");
    }
}

await mounted();

</script>
